$(document).ready(function () {
    const $newsletterForm = $('.newsletter-sf__form .wpcf7');

    if (!$newsletterForm.length) {
        return;
    }

    $newsletterForm.on('wpcf7invalid wpcf7spam wpcf7mailfailed', function () {
        const $container = $(this).closest('.newsletter-sf__form');
        $container.find('.newsletter-sf__message--error').fadeIn(300);
    });

    $newsletterForm.on('wpcf7mailsent', function () {
        const $container = $(this).closest('.newsletter-sf__form');
        $container.find('.wpcf7, .newsletter-sf__message--error').hide();
        $container.find('.newsletter-sf__message--success').fadeIn(300);
    });
});
